import { LitElement, html, svg } from 'lit';

export class IconLike24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Tommel opp</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 10c2.283-1.674 5.4-4.46 7.827-8.357.351-.564 1.14-.675 1.61-.206l.59.59a1 1 0 0 1 .215 1.091L14 8.5h7.126a2 2 0 0 1 1.97 2.34l-1.81 10.5a2 2 0 0 1-1.97 1.66H10l-4-2.5M6 8H1v14h5V8Z"></path></svg>`; }
}
if (!customElements.get('f-icon-like24', IconLike24)) {
  customElements.define('f-icon-like24', IconLike24);
}